/** Koşullu sınıf birleştirme — shadcn'deki `cn`'in bağımlılıksız hâli. */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
